<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card>
      <v-card-title primary-title>
        Transfer of Rights / Change Name
      </v-card-title>
      <v-card-text>
        <VButton :items="items" @onPress="onPress" />
      </v-card-text>
    </v-card>
    <!-- component for axios submit -->
    <AlertDialog
      :props_data="props_data"
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <div class="my-2 w-full">
      <v-btn class="w-full" color="blue" @click="submitTicket">
        Submit Request</v-btn
      >
    </div>
    <!-- ================== -->
  </div>
</template>

<script>
import VButton from "@/common/VButtons.vue";
import BackButton from "@/common/BackButton.vue";
import AlertDialog from "../../common/AlertDialog.vue";
export default {
  data() {
    return {
      props_data: {},
      penalties_to_waive: "",
      showAlert: false,
      items: [
        {
          title: "I have not fully paid the account yet",
          route: "not-fully-paid",
        },
        {
          title: "I have fully paid the account yet",
          route: "fully-paid",
        },
      ],
    };
  },
  components: {
    AlertDialog,
    BackButton,
    VButton,
  },
  methods: {
    submitTicket() {
      this.showAlert = true;
      this.props_data = {
        status_id: 1,
        remarks_id: 1,
        classification_id: this.$route.meta.classification_id,
        request_type_id: this.$route.meta.request_type_id,
        department_id: 10,
        subject: this.$route.meta.subject,
      };
    },
    onPress(e) {
      this.$router.push({ name: e.route });
    },
    back(n) {
      this.$router.push({ name: n });
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
};
</script>